import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectTypesFetchFailedAction = {
	type: 'SUBJECT_TYPES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectTypesFetchFailedAction => ({
	type: 'SUBJECT_TYPES_FETCH_FAILED',
	payload,
});
